import {useIsLargishAndUp} from '~/common/hooks/useMatchQuery';
import {Link} from '~library/atoms/Link';
import {Typography} from '~library/atoms/Typography';
import {useTracking} from '~library/context/tracking/tracking-context';
import * as styles from './AccountDetailsProCTA.module.scss';

export const AcctDetailsProCTA = () => {
  const isLargishAndUp = useIsLargishAndUp();
  const {track} = useTracking();

  const handleProCTAClick = () => {
    track({
      dataQaId: 'pro-cta',
      href: '/pro',
      ctaType: 'account-drawer-pro',
    });
  };

  return (
    <div className={styles.container}>
      <div className={styles.info}>
        <Typography variant={isLargishAndUp ? 'paragraph3' : 'paragraph2'} semibold>
          Hosting a lot this year?
        </Typography>
        <Typography variant={isLargishAndUp ? 'paragraph3' : 'paragraph2'}>
          Save with Evite Pro
        </Typography>
      </div>
      <Link
        as="primary"
        href="/pro"
        data-qa-id="learn-more"
        onClick={handleProCTAClick}
        className={styles.cta}
        variant="small"
      >
        Learn more
      </Link>
    </div>
  );
};
